import { jsx } from "react/jsx-runtime";
const EnergyClass = (props) => {
  const { prefix = "", children } = props;
  if (!children) return null;
  return /* @__PURE__ */ jsx("span", { className: `${prefix}price-module__energy-class`, children });
};
var EnergyClass_default = EnergyClass;
export {
  EnergyClass,
  EnergyClass_default as default
};
